import React from "react";
import Modal from "react-modal";
import { AxiosResponse } from "axios";

import { IService, IPageContent, IServiceCategory } from "app/api/types";
import AddService from "./components/AddService";

import Service from "./components/Service";
import BackButton from "app/features/BackButton";
import Loader from "app/components/Loader";

import "./styles.scss";

interface IProps {
  serviceCategoriesList: IServiceCategory[];
  serviceList: IService[];
  isLoading: boolean;
  addService: (data: IService) => Promise<IService>;
  delService: (email: IService["id"]) => Promise<AxiosResponse>;
  editService: (data: IService) => Promise<IService>;
  getServices: () => Promise<AxiosResponse>;
  getPageContentById: (id: string) => Promise<[IPageContent]>;
  addPageContent: (data: IPageContent) => Promise<AxiosResponse>;
  delPageContent: (id: IPageContent["pageId"]) => Promise<AxiosResponse>;
  editPageContent: (data: IPageContent) => Promise<AxiosResponse>;
}

interface IState {
  modalIsOpen: boolean;
  isSuccessActive: boolean;
  isSubmit: boolean;
}

const schemeContent = [
  {
    id: "main-logo",
    title: "Изображение(702x477)",
    src: "",
  },
  {
    id: "main-description",
    title: "Главное описание",
    text: "",
  },
  {
    id: "header_1",
    title: "Заголовок(1)",
    text: "",
  },
  {
    id: "description_1",
    title: "Описание(1)",
    text: "",
  },
  {
    id: "header_2",
    title: "Заголовок(2)",
    text: "",
  },
  {
    id: "description_2",
    title: "Описание(2)",
    text: "",
  },
  {
    id: "record-description",
    title: "Описание над кнопкой",
    text: "",
  },
];

Modal.setAppElement("#root");

class ServiceList extends React.Component<IProps, IState> {
  state = {
    modalIsOpen: false,
    isSuccessActive: false,
    isSubmit: false,
  };

  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  addService = (data: IService) => {
    this.props.addService(data).then((service) => {
      this.props.editService({
        ...service,
        href: `service.${service.id}`,
      });

      this.props.addPageContent({
        pageId: `service.${service.id}`,
        pageTitle: service.title,
        content: schemeContent,
      });

      this.props.getServices();
    });
    this.setState({ isSubmit: false, isSuccessActive: false });
    this.closeModal();
  };

  editService = (data: IService) => {
    this.props.editService(data).then(() => {
      this.props.getPageContentById(data.href).then((pageContent) => {
        this.props.editPageContent({
          pageId: pageContent[0].pageId,
          pageTitle: data.title,
          content: pageContent[0].content,
        });
      });

      this.props.getServices();
    });
  };

  delService = (id: IService["id"]) => {
    this.props.delService(id).then(() => {
      this.props.delPageContent(`service.${id}`);
      this.props.getServices();
    });
  };

  onSuccessChange = (active: boolean) => {
    this.setState({ isSuccessActive: active });
  };

  render() {
    if (this.props.isLoading)
      return (
        <div className="loader-wrapper">
          <Loader />
        </div>
      );

    return (
      <div className="user-group">
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Add phrase modal"
          className="user-group__modal"
          overlayClassName="user-group__overlay"
        >
          <button onClick={this.closeModal} className="modal-close" />
          <AddService
            onSubmit={this.addService}
            onSuccessChange={this.onSuccessChange}
            isSubmit={this.state.isSubmit}
          />
          {this.state.isSuccessActive && (
            <button
              onClick={() => this.setState({ isSubmit: true })}
              className="modal-success"
            />
          )}
        </Modal>

        <div className="user-group__header">
          <div className="header__back-button">
            <BackButton to="/" />
          </div>

          <div className="header__group-label">
            <p className="label__text">Услуги</p>
            <p className="label__counter">{this.props.serviceList.length}</p>
            <button className="label__add-button" onClick={this.openModal} />
          </div>
        </div>

        <div className="user-group__content">
          <div className="column">
            {this.props.serviceList.map((service) => (
              <Service
                serviceCategoriesList={this.props.serviceCategoriesList}
                service={service}
                onSubmit={this.editService}
                onDelete={this.delService}
                key={service.id}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default ServiceList;
